import pagesNiv3et4Codes from "@/utils/pages-niv3&4-codes";

export const quickFiltersProps = () => ({
  quickFilters: {
    type: Array,
    required: false,
    default: () => []
  },
  isLeft: {
    type: Boolean,
    required: false,
    default: false
  }
});

export const quickFiltersEmits = () => ["select"];

export const useQuickFilters = (props, emit) => {
  const quickFiltersFormatted = computed(() => {
    let qf = [];
    if (props.quickFilters && props.quickFilters.length > 0) {
      props.quickFilters.forEach((filter) => {
        const isBooleanFilter = filter.render_mode === pagesNiv3et4Codes.BOOLEAN_MODE;
        const isListMode = filter.render_mode === pagesNiv3et4Codes.QUICKFILTER_LIST_RENDER_MODE;
        if (isListMode) {
          qf = [
            ...qf,
            {
              mode: "list",
              libelle: filter.libelle,
              values: filter.values.map((v) => {
                return {
                  libelle_filter: filter.libelle,
                  actif: v.actif,
                  code: filter.code,
                  valeur: v.valeur,
                  libelle_value: v.libelle,
                  libelle: v.libelle,
                  nb_total_produits: v.nb_total_produits,
                  picto: v.picto
                };
              })
            }
          ];
        } else {
          qf = [
            ...qf,
            ...filter.values
              .filter((v) => !isBooleanFilter || v.libelle === "1")
              .map((v) => {
                return {
                  libelle_filter: filter.libelle,
                  actif: v.actif,
                  code: filter.code,
                  valeur: v.valeur,
                  libelle_value: v.libelle,
                  libelle: isBooleanFilter ? filter.libelle : v.libelle,
                  nb_total_produits: v.nb_total_produits,
                  picto: v.picto
                };
              })
          ];
        }
      });
    }
    return qf.slice(0, 5).sort((a, b) => {
      if (a.mode === "list") {
        return 1;
      }
      if (b.mode === "list") {
        return -1;
      }
      return 0;
    });
  });

  const change = (checked, quickfilter) => {
    emit(
      "select",
      checked,
      quickfilter.code,
      quickfilter.valeur,
      quickfilter.libelle_value,
      quickfilter.libelle_filter,
      true
    );
  };

  return { quickFiltersFormatted, change };
};
